module.exports = __webpack_public_path__ + "static/media/licenca_frente.189139a7.pdf";